export default {
  title: 'Spatial SQL'
}
